<template>
  <div
    class="dma-popup-content"
    :class="`${skin} ${isRtlDirection ? 'rlt' : ''} ${
      nopadding ? 'nopadding' : ''
    }`"
  >
    <a
      href="javascript:;"
      class="dma-popup-close"
      @click="closeTerms"
      v-show="useCloseBtn"
    ></a>
    <div class="dma-popup-language" v-show="showLanguage">
      <div class="dma-popup-language-box">
        <div class="lang-icon"></div>
        <select class="dma-popup-language-select" v-model="curLang">
          <option v-for="(text, lang) in langList" :key="lang" :value="lang">
            {{ text }}
          </option>
        </select>
        <div class="tra-icon"></div>
      </div>
    </div>

    <template v-if="!~detailTerm">
      <div class="dma-popup-content-main">
        <div
          class="term-list-item"
          v-for="(item, index) in termList"
          :key="index"
          :class="{ warn: isWarnList(index) }"
        >
          <div
            class="checkbox"
            :class="{
              on: isSelect(index),
              disable: isFromUserCenter && isRequire(index)
            }"
            @click="toggleSelect(index)"
          >
            <div class="gou"></div>
          </div>
          <div class="title" @click="gotoDetail(index)">
            <div>{{ item.name }}</div>
            <a href="javascript:;" class="go-icon"></a>
          </div>
        </div>

        <div class="tips" v-show="this.warnList.length">
          {{ txt('dma_qxgxxy') }}
        </div>
      </div>
      <template v-if="isFromUserCenter">
        <div class="dma-popup-footer">
          <a
            href="javascript:;"
            class="dma-popup-footer-btn"
            @click="closeTerms"
            >{{ txt('dma_back') }}</a
          >
          <a
            href="javascript:;"
            class="dma-popup-footer-btn primary"
            @click="excAgree"
            >{{ txt('dma_save') }}</a
          >
        </div>
      </template>
      <template v-else>
        <div class="dma-popup-footer">
          <a
            href="javascript:;"
            class="dma-popup-footer-btn"
            :class="{ primary: isSelectRequire }"
            @click="excAgree"
            >{{ txt('dma_agree') }}</a
          >
          <a
            href="javascript:;"
            class="dma-popup-footer-btn primary"
            @click="excAgreeAll"
            >{{ txt('dma_allAgree') }}</a
          >
        </div>
      </template>
    </template>
    <template v-else>
      <div
        class="dma-popup-content-main"
        :class="{ 'un-language': !showLanguage }"
      >
        <div class="term-detail-txt" v-show="detailInfo.content">
          <div class="title" v-show="detailInfo.title">
            {{ detailInfo.title || '' }}
          </div>
          <div class="content">{{ detailInfo.content || '' }}</div>
        </div>
        <div class="term-detail-link" v-show="detailInfo.link">
          <iframe :src="getCurTermLink(detailInfo.link)"></iframe>
        </div>
      </div>
      <div class="dma-popup-footer">
        <a href="javascript:;" class="dma-popup-footer-btn" @click="backList">{{
          txt('dma_back')
        }}</a>
        <a
          href="javascript:;"
          class="dma-popup-footer-btn primary"
          @click="agreeAndBack"
          >{{ txt('dma_agree') }}</a
        >
      </div>
    </template>
  </div>
</template>

<script>
import globalConfig from '@utiles/globalConfig';
import bridge from '@utiles/bridge';
import { getDefaultTermList, getLanguage, getLanguageList } from './config';

const mainHost = globalConfig.getMainHost();
let detailPageName = '协议详情页面';

export default {
  name: 'dmaPopup',
  props: {
    isFromUserCenter: {
      type: Boolean,
      default: false
    },
    skin: {
      type: String,
      default: 'store'
    },
    useCloseBtn: {
      type: Boolean,
      default: true
    },
    nopadding: {
      type: Boolean,
      default: false
    },
    defaultSelect: {
      type: String,
      default: ''
    }
  },
  data() {
    let gameId =
      globalConfig.getHrefParam('gameId') ||
      globalConfig.getHrefParam('gameID') ||
      globalConfig.getHrefParam('game_id') ||
      '';

    return {
      gameId,
      curPageName: '',
      curSubPageName: '',
      detailTerm: -1,
      selectTerms: [],
      warnList: [],
      isCheck: false
    };
  },
  computed: {
    termList() {
      return getDefaultTermList(this.curLang);
    },
    langList() {
      return { ...getLanguageList(), ...this.$store.state.dma.languageList };
    },
    isRtlDirection() {
      return this.$store.state.dma.isRtlDirection;
    },
    curLang: {
      get() {
        return this.$store.state.dma.curLang;
      },
      set(val) {
        this.$store.commit('switchLang', val);
        window.dmaDataLayer.push({
          eventName: 'click_button',
          eventType: '切换语言',
          eventReason: this.curPageName,
          eventValue: val
        });
      }
    },
    isSelectRequire() {
      let requireArr = this.termList.reduce((total, value, index) => {
        if (value.require) {
          total.push(index);
        }
        return total;
      }, []);
      let res = true;
      for (let i = 0; i < requireArr.length; i++) {
        if (!this.selectTerms.includes(requireArr[i])) {
          res = false;
          break;
        }
      }
      return res;
    },
    detailInfo() {
      if (!~this.detailTerm) return {};
      return this.termList[this.detailTerm] || {};
    },
    pageName() {
      return this.isFromUserCenter ? '修改协议选项页面' : '游戏启动协议弹窗';
    },
    showLanguage() {
      // 协议页和隐私页是没得切换语言的，所以隐藏一下
      return (
        !~this.detailTerm ||
        (~this.detailTerm && this.termList[this.detailTerm]?.content)
      );
    }
  },
  created() {
    this.initSelectTerm();
    this.curPageName = this.pageName;
    try {
      window.setPhoneReturnCb(true, () => {
        this.closeTerms();
      });
    } catch (error) {}

    // 访问打点
    window.dmaDataLayer.push({
      eventName: 'view_page',
      eventType: this.curPageName,
      eventReason: this.curSubPageName
    });
  },
  beforeDestroy() {
    try {
      window.setPhoneReturnCb(false);
    } catch (error) {}
  },
  methods: {
    initSelectTerm() {
      let selectTerms = [];
      // 用户中心默认选中必选
      if (this.isFromUserCenter) {
        let _termList = getDefaultTermList();
        selectTerms = _termList.reduce((total, item, index) => {
          if (item.require) {
            total.push(index);
          }
          return total;
        }, []);
        // 再来判断一下可选
        let optionalArr = String(this.defaultSelect).split('');
        let requireLen = selectTerms.length;
        optionalArr.forEach((item, index) => {
          let curIndex = +index + +requireLen;
          if (!_termList[curIndex]) return;
          if (_termList[curIndex].require) return;
          // 1为选中，0为没选
          if (item == 1) {
            selectTerms.push(curIndex);
          }
        });
      }
      this.selectTerms = selectTerms;
    },
    isSelect(index) {
      return this.selectTerms.includes(index);
    },
    isWarnList(index) {
      return this.warnList.includes(index);
    },
    toggleSelect(index) {
      if (this.isRequire(index) && this.isFromUserCenter) return;
      if (this.isSelect(index)) {
        let _i = this.selectTerms.findIndex(item => item == index);
        this.selectTerms.splice(_i, 1);
        return;
      }
      this.selectTerms.push(index);
      if (this.warnList.includes(index)) {
        let _i = this.warnList.findIndex(item => item == index);
        this.warnList.splice(_i, 1);
      }
    },
    gotoDetail(index) {
      this.detailTerm = index;
      this.curPageName = detailPageName;
      this.curSubPageName = getDefaultTermList('zh-CN')[index].name;
      // 访问打点
      window.dmaDataLayer.push({
        eventName: 'view_page',
        eventType: this.curPageName,
        eventReason: this.curSubPageName
      });
      try {
        window.setPhoneReturnCb(true, () => {
          this.backList();
        });
      } catch (error) {}
    },
    backList(_e, ignorePoint = false) {
      if (!ignorePoint) {
        window.dmaDataLayer.push({
          eventName: 'click_button',
          eventType: '返回（从详情回到列表）',
          eventValue: this.curSubPageName,
          eventReason: this.curPageName
        });
      }

      this.$nextTick(() => {
        this.detailTerm = -1;
        this.curPageName = this.pageName;
        this.curSubPageName = '';
      });

      try {
        window.setPhoneReturnCb(true, () => {
          this.closeTerms();
        });
      } catch (error) {}
    },
    async agreeAndBack() {
      if (!this.isSelect(this.detailTerm)) {
        this.selectTerms.push(this.detailTerm);
      }
      window.dmaDataLayer.push({
        eventName: 'click_button',
        eventType: '同意并返回',
        eventValue: getDefaultTermList('zh-CN')[this.detailTerm].name,
        eventReason: this.curPageName
      });
      this.$nextTick(() => {
        this.backList(null, true);
      });
    },
    sleep(time) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, time * 1000);
      });
    },
    excAgree(_e, ignorePoint = false) {
      this.isCheck = true;
      this.warnList = [];
      for (let i = 0; i < this.termList.length; i++) {
        if (this.termList[i].require && !this.selectTerms.includes(i)) {
          this.warnList.push(i);
        }
      }
      if (this.warnList.length) {
        !ignorePoint &&
          window.dmaDataLayer.push({
            eventName: 'click_button',
            eventType: '同意',
            eventValue: '未勾选必选项',
            eventReason: this.curPageName
          });
        return;
      }
      !ignorePoint &&
        window.dmaDataLayer.push({
          eventName: 'click_button',
          eventType: '同意',
          eventValue: '已勾选必选项',
          eventReason: this.curPageName
        });
      
      // 从URL获取参数
      const urlParams = new URLSearchParams(window.location.search);
      const protocolId = urlParams.get('protocolId');
      const apps = urlParams.get('apps');
      
      // 构建consentMode
      let consentMode = '';
      this.termList.forEach((item, index) => {
        if (item.require) return;
        consentMode += this.selectTerms.includes(index) ? '1' : '0';
      });
      
      // 请求接口
      if (protocolId && apps) {
        fetch(`https://geventsapi.${mainHost}/protocolPopup/clickCallBack?protocolId=${protocolId}&apps=${apps}`)
          .then(response => response.json())
          .then(res => {
            if (+res.result === 1) {
              this.$emit('submitDma', consentMode);
            }
          })
          .catch(error => console.error('请求失败:', error));
      } else {
        // 如果没有protocolId和apps参数，直接执行提交
        this.$emit('submitDma', consentMode);
      }
    },
    closeTerms() {
      this.$emit('closePopup');
    },
    async excAgreeAll() {
      this.selectTerms = this.termList.reduce((total, _item, index) => {
        total.push(index);
        return total;
      }, []);
      window.dmaDataLayer.push({
        eventName: 'click_button',
        eventType: '全部同意',
        eventValue: '',
        eventReason: this.curPageName
      });
      
      await this.sleep(1);
      this.excAgree(null, true);
    },
    txt(key) {
      return getLanguage(this.curLang, key);
    },
    getCurTermLink(link) {
      try {
        let url = new URL(link);
        url.searchParams.set('gameId', this.gameId);
        url.searchParams.set('language', this.curLang);
        url.hostname = `gpassport.${mainHost}`;
        return url.href;
      } catch (error) {
        return link;
      }
    },
    isRequire(index) {
      return this.termList[index].require;
    }
  }
};
</script>

<style lang="scss">
@import '@assets/scss/base.scss';
@import '@assets/scss/platform-dma.scss';
</style>
